module.exports = __webpack_public_path__ + "img/space.e9108952.png";